// src/components/LeadFeatures.js
import React from "react";
import "./lead-screens.css";

const Icon = ({ name }) => {
  const common = {
    width: 44,
    height: 44,
    stroke: "currentColor",
    strokeWidth: 1.6,
    fill: "none",
  };

  switch (name) {
    case "shield":
      return (
        <svg {...common} viewBox="0 0 24 24">
          <path d="M12 3l8 4v5c0 5.25-3.75 9.75-8 11-4.25-1.25-8-5.75-8-11V7l8-4z" />
        </svg>
      );
    case "check":
      return (
        <svg {...common} viewBox="0 0 24 24">
          <path d="M5 13l4 4L19 7" />
        </svg>
      );
    case "brain":
      return (
        <svg {...common} viewBox="0 0 24 24">
          <path d="M8 3a4 4 0 00-4 4v2a4 4 0 004 4v6" />
          <path d="M16 3a4 4 0 014 4v2a4 4 0 01-4 4v6" />
        </svg>
      );
    case "rocket":
      return (
        <svg {...common} viewBox="0 0 24 24">
          <path d="M5 15l3 3 3-3-3-3-3 3zM15 3l6 6-7.5 7.5L7.5 10.5 15 3z" />
        </svg>
      );
    default:
      return null;
  }
};

export default function LeadFeatures() {
  return (
    <section className="lm-section features-section">
      <div className="container">
        <header className="hero">
          <div>
            <h1 className="title">MarketMind4U — Growth Engine</h1>
            <p className="subtitle">
              AI-powered visibility, verified enquiries, hyperlocal reach and
              real business growth — built for serious local brands.
            </p>

            <div className="hero-ctas">
              <button className="btn primary">Get First Lead</button>
              <button className="btn ghost">View Demo</button>
            </div>
          </div>

          <div className="hero-stats">
            <div className="stat">
              <div className="stat-num">1,200+</div>
              <div className="stat-label">Active Businesses</div>
            </div>
            <div className="stat">
              <div className="stat-num">72H</div>
              <div className="stat-label">Avg First Lead</div>
            </div>
            <div className="stat">
              <div className="stat-num">4.6★</div>
              <div className="stat-label">Rating Growth</div>
            </div>
          </div>
        </header>

        <div className="features-grid">
          <article className="feature-card">
            <div className="icon-wrap"><Icon name="shield" /></div>
            <h3>High-Intent Leads</h3>
            <p className="muted">
              Enquiries filtered by intent, location and buyer behaviour.
            </p>
            <ul className="bullets">
              <li>WhatsApp-ready</li>
              <li>Phone verification</li>
              <li>Real buyer signals</li>
            </ul>
          </article>

          <article className="feature-card">
            <div className="icon-wrap accent"><Icon name="check" /></div>
            <h3>Verified Enquiries</h3>
            <p className="muted">
              Spam-free system powered by AI validation checks.
            </p>
          </article>

          <article className="feature-card">
            <div className="icon-wrap"><Icon name="brain" /></div>
            <h3>AI Growth Autopilot</h3>
            <p className="muted">
              SEO, posts, reviews and ads — optimized automatically.
            </p>
          </article>

          <article className="feature-card">
            <div className="icon-wrap accent2"><Icon name="rocket" /></div>
            <h3>Hyperlocal Targeting</h3>
            <p className="muted">
              Reach buyers inside your most profitable radius.
            </p>
          </article>
        </div>

        <div className="feature-cta-row">
          <h3>Want more calls & visits from nearby customers?</h3>
          <button className="btn primary large">Start Free Audit</button>
        </div>
      </div>
    </section>
  );
}
